<div class="container-fluid hero-section">
  <div class="row align-items-center">
    <!-- Left: Content -->
    <div class="col-lg-6 col-md-12 hero-content">
      <div class="hero-line"></div>
      <h1>Empowering Businesses with Artificial Intelligence</h1>
      <p>
        At MALtech, we harness the power of Artificial Intelligence, Machine
        Learning, and Data Science to analyze data, unlock insights, optimize
        processes, and drive enterprise-wide innovation.
      </p>
      <a routerLink="/contact" href="/contact" class="btn hero-btn">Reach Us</a>
    </div>

    <!-- Right: Image -->
    <div class="col-lg-6 col-md-12 hero-image text-center">
      <img
        src="assets/images/ai/AI-header.webp"
        alt="Two people looking at a large screen with data and diagrams."
        class="img-fluid"
        width="450"
        loading="lazy"
      />
    </div>
  </div>
</div>

<div class="container">
  <div class="header1">
    <h2 class="text-center industries-heading">
      Transforming Ideas into Intelligent Solutions
    </h2>
    <p class="px-2 text-justify text-md-start jus">
      From automation to advanced analytics, MALTech delivers AI-powered
      solutions that help organizations innovate, scale, and stay future-ready.
      With expertise in ML, DL, NLP, and Computer Vision, we deliver intelligent
      solutions tailored to your business.
    </p>
  </div>

  <div class="card-container">
    <div class="card">
      <div class="icon-placeholder">
        <img
          src="assets/images/ai/TI.webp"
          alt="Machine Learning Icon"
          loading="lazy"
        />
      </div>
      <div class="card-content">
        <h3>Machine Learning Models</h3>
        <p>
          AI-powered algorithms analyze data to predict trends and enhance
          performance.
        </p>
      </div>
    </div>

    <div class="card">
      <div class="icon-placeholder">
        <img
          src="assets/images/ai/TI2.webp"
          alt="AI-Powered Automation Icon"
          loading="lazy"
        />
      </div>
      <div class="card-content">
        <h3>AI-Powered Automation</h3>
        <p>
          Automate repetitive tasks and processes with intelligent bots and
          workflows.
        </p>
      </div>
    </div>

    <div class="card">
      <div class="icon-placeholder">
        <img
          src="assets/images/ai/TI3.webp"
          alt="Predictive Analytics Icon"
          loading="lazy"
        />
      </div>
      <div class="card-content">
        <h3>Predictive Analytics</h3>
        <p>
          Leverage predictive analytics to gain insights and forecast key
          trends.
        </p>
      </div>
    </div>
  </div>
</div>
<br />

<div class="industries-section" id="get-start">
  <h2 class="industries-heading">Industries We Serve</h2>
  <div class="card-grid">
    <div class="industry-card">
      <div class="icon"><i class="bi bi-cart"></i></div>
      <div class="card-title">Retail &amp; E-Commerce</div>
      <div class="card-desc">
        AI improves recommendations, demand forecasting, and efficiency
      </div>
    </div>
    <div class="industry-card">
      <div class="icon"><i class="bi bi-shield-lock"></i></div>
      <div class="card-title">IT &amp; Cybersecurity</div>
      <div class="card-desc">
        Our AI protects systems by detecting threats and automating defense.
      </div>
    </div>
    <div class="industry-card">
      <div class="icon"><i class="bi bi-truck"></i></div>
      <div class="card-title">Logistics &amp; Supply Chain</div>
      <div class="card-desc">
        AI optimizes routes, cuts costs, and speeds delivery.
      </div>
    </div>
    <div class="industry-card">
      <div class="icon"><i class="bi bi-cloud"></i></div>
      <div class="card-title">Cloud Data Solutions</div>
      <div class="card-desc">
        We use AWS, Azure & Google Cloud for secure, flexible data storage.
      </div>
    </div>
  </div>
</div>

<div class="container">
  <h2 class="text-center industries-heading mb-4">Our AI Process</h2>

  <div class="position-relative">
    <!-- Vertical timeline line -->
    <div
      class="timeline-line position-absolute top-0 start-2 translate-middle-x"
    ></div>

    <div
      *ngFor="let step of steps; let i = index"
      class="d-flex mb-5 position-relative"
    >
      <!-- Icon -->
      <div
        class="timeline-icon d-flex align-items-center justify-content-center"
      >
        <i class="bi {{ step.icon }} fs-3 text-primary"></i>
      </div>

      <!-- Content -->
      <div class="ms-3">
        <h5 class="fw-bold">{{ step.title }}</h5>
        <p class="mb-0">{{ step.description }}</p>
      </div>
    </div>
  </div>
</div>

<div class="maltech-container">
  <div class="maltech-header mb-3">
    <span class="maltech-title">Why Choose MALtech</span>
  </div>
  <div class="maltech-content">
    <div class="maltech-image">
      <img
        src="assets/images/ai/Ai-section.webp"
        alt="Data Analytics Dashboard"
        width="360"
        loading="lazy"
      />
    </div>
    <div class="maltech-description">
      <h2 class="maltech-subtitle text-center">
        Empowering Businesses with Smart, Scalable, and Secure AI Solutions.
      </h2>
      <p class="maltech-paragraph ">
        At MALtech, we combine deep expertise in AI, Machine Learning, and Data
        Science with a client-focused approach to deliver intelligent, scalable,
        and secure solutions. We craft strategies that fuel growth, innovation,
        and resilience, keeping businesses future-ready.
      </p>
      <p class="maltech-paragraph">
        With proven expertise across Cloud, AI, DevOps, Cybersecurity, Software
        Development, and Data Science, MALtech is a trusted partner for
        enterprises worldwide seeking to harness technology for long-term
        success.
      </p>
    </div>
  </div>
</div>

<section class="faq">
  <h2>Frequently Asked Questions</h2>
  <p class="faq-desc">
    Our FAQ addresses common customer questions across every stage of the
    journey.
  </p>

  <div class="accordion">
    <div class="accordion-item" *ngFor="let f of faqs; index as i">
      <button class="accordion-header" (click)="toggleFaq(i)">
        <span>{{ f.q }}</span>
        <span class="chev" [class.open]="openFaqIndex === i">▾</span>
      </button>
      <div class="accordion-body" [class.open]="openFaqIndex === i">
        <p>{{ f.a }}</p>
      </div>
    </div>
  </div>
</section>

<section class="solutions-section">
  <h2 class="solutions-title">Let’s Build Intelligent Solutions Together</h2>
  <p class="solutions-subtitle">
    Partner with MALtech to harness AI and transform your business with
    intelligent, scalable, and secure solutions.
  </p>
  <a
    class="contact-btn text-decoration-none"
    [routerLink]="['/contact']"
    [href]="['/contact']"
    rel="noopener noreferrer"
    aria-label="Contact Us "
  >
    Contact Us
  </a>
  <br><br>
</section>

